import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const updateRegularOffer = (id, changes) => {
	return fetch(apiBasename + '/regularOffer/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removeRegularOffer = (id) => {
	return fetch(apiBasename + '/regularOffer/' + id, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
};
